import { LogoLockup } from "./Logo";
import { scrollToSection } from "./Navbar";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();

  const NAV = [
    ["#chi-siamo", t("Chi siamo", "About"), "footer-link-chi-siamo"],
    ["#servizi", t("Servizi", "Services"), "footer-link-servizi"],
    ["#lavori", t("I nostri lavori", "Our projects"), "footer-link-lavori"],
    ["/guide", t("Guide", "Guides"), "footer-link-guide", true],
    ["#contatti", t("Contatti", "Contact"), "footer-link-contatti"],
  ];

  return (
    <footer data-testid="site-footer" className="relative border-t border-[#D4AF37]/15 bg-[#050A12]">
      <div className="gold-hairline" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <LogoLockup />
          <p className="mt-5 text-sm text-slate-400 leading-relaxed max-w-xs">
            {t(
              "Impresa edile a Bologna. Esperienza, qualità e affidabilità dal cantiere alla consegna.",
              "Construction company in Bologna. Experience, quality and reliability from the worksite to delivery."
            )}
          </p>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">{t("Navigazione", "Navigation")}</h4>
          <ul className="mt-5 flex flex-col gap-3">
            {NAV.map(([href, label, id, isRoute]) => (
              <li key={id}>
                {isRoute ? (
                  <a href={href} data-testid={id} className="text-sm text-slate-400 hover:text-[#F3E08B] transition-colors">
                    {label}
                  </a>
                ) : (
                  <a
                    href={href}
                    data-testid={id}
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToSection(href);
                    }}
                    className="text-sm text-slate-400 hover:text-[#F3E08B] transition-colors"
                  >
                    {label}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] font-semibold">{t("Contatti", "Contact")}</h4>
          <ul className="mt-5 flex flex-col gap-3 text-sm text-slate-400">
            <li>Via della Beverara 129, 40131 Bologna (BO)</li>
            <li>
              <a href="tel:+393514665019" data-testid="footer-phone-link" className="hover:text-[#F3E08B] transition-colors">
                +39 351 466 5019
              </a>
            </li>
            <li>
              <a href="mailto:adriaticasrlbologna@gmail.com" data-testid="footer-email-link" className="hover:text-[#F3E08B] transition-colors">
                adriaticasrlbologna@gmail.com
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} Adriatica S.r.l. Semplificata · {t("P.IVA", "VAT no.")} 03525571208 — {t("Tutti i diritti riservati", "All rights reserved")}
          </p>
          <p className="text-[11px] uppercase tracking-[0.3em] text-[#9A7B2C]">
            {t("Esperienza • Qualità • Affidabilità", "Experience • Quality • Reliability")}
          </p>
        </div>
      </div>
    </footer>
  );
};
